export default "/assets/images/mila-feed-04-thumbnail.jpg?7b58e585f8844fb3e796e7b6fed399c8";